import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { resetPasswordTokenAction } from '../../actions/usersActions';
//Función principal
const ResetPasswordForm = props => {
    //Tomo los props
    const { token } = props;
    //Inicializo el history
    const history = useHistory();
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store
    const usersLoading = useSelector(state => state.users.loading);
    //Inicializo el state local
    const [ user, setUser ] = useState({
        token,
        email: '',
        newPassword: '',
        newPasswordRepeat: ''
    });
    //Manejo el submit
    const handleSave = values => {
        //Armo la data
        const data = {
            email: values.email,
            newPassword: values.newPassword,
            newPasswordRepeat: values.newPasswordRepeat,
            token
        }
        //Llamo al dispatch
        dispatch( resetPasswordTokenAction(data, history) );
    }
    //Esquema de validación
    const validationSchema = yup.object({
        email: yup.string().email().required(),
        newPassword: yup.string().min(6, 'Debe tener al menos 6 caracteres').nullable('El campo es obligatorio'),
        newPasswordRepeat: yup.string().min(6).oneOf([yup.ref('newPassword'), null], 'Las contraseñas deben coincidir')
    });
    //Renderizo
    return (
        <React.Fragment>
            <div className="text-center">
                <h1 className="h4 text-gray-900 mb-2">Resetear contraseña</h1>
                <p className="mb-4">
                    Ingrese a continuación la dirección de mail con la que se registró, su nueva contraseña y confirme la misma. 
                </p>
            </div>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...user }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate className="user" onSubmit={handleSubmit} autoComplete="off">
                        <div className="form-group">
                            <Form.Control
                                id="email"
                                className="form-control form-control-user"
                                autoFocus
                                name="email" 
                                type="email" 
                                value={ values.email }
                                onChange={handleChange}
                                // ref={refApellido}
                                isInvalid={!!errors.email}
                                disabled={ usersLoading }
                                placeholder="Ingrese su email..."
                            />
                            <Form.Control.Feedback type="invalid">
                                { errors.email }
                            </Form.Control.Feedback>
                        </div>
                        <div className="form-group">
                            <Form.Control
                                id="newPassword"
                                className="form-control form-control-user"
                                name="newPassword" 
                                type="password" 
                                value={ values.newPassword }
                                onChange={handleChange}
                                // ref={refApellido}
                                isInvalid={!!errors.newPassword}
                                disabled={ usersLoading }
                                placeholder="Nueva contraseña..."
                            />
                            <Form.Control.Feedback type="invalid">
                                { errors.newPassword }
                            </Form.Control.Feedback>
                        </div>
                        <div className="form-group">
                            <Form.Control
                                id="newPasswordRepeat"
                                className="form-control form-control-user"
                                name="newPasswordRepeat" 
                                type="password" 
                                value={ values.newPasswordRepeat }
                                onChange={handleChange}
                                // ref={refApellido}
                                isInvalid={!!errors.newPasswordRepeat}
                                disabled={ usersLoading }
                                placeholder="Confirmar contraseña..."
                            />
                            <Form.Control.Feedback type="invalid">
                                { errors.newPasswordRepeat }
                            </Form.Control.Feedback>
                        </div>
                        <Button type="submit" variant="primary" className="btn-user btn-block">
                            Resetear contraseña
                        </Button>
                    </form>
                )}
            </Formik>
            <hr />
            <div className="text-center">
                <Link className="small" to="/iniciar-sesion">
                    Recordó su contraseña? Inicie sesión
                </Link>
            </div>
        </React.Fragment>
    );
};

export default ResetPasswordForm;